export const HERO_CONSTANTS = {
  button: {
    label: "Maximize IT performance with lab-driven validation",
    link: "#contact-us",
  },
  title: "High-Performance IT Solutions with Testing Labs",
};
